import { useDispatch, useSelector } from "react-redux";
import { showPopup } from "/redux/action-creaters/popup";
import { popupTypes } from "/redux/reducers/popupReducer";
import React, { useEffect, useMemo, useState } from "react";
import { declOfNum } from "/utils";
import Link from "next/link";
import Search from "/components/layouts/main/search";
import Catalog from "/components/layouts/main/catalog";
import Button from "/components/common/button";
import Cart from "/components/layouts/main/cart";
import User from "/components/layouts/main/user/";
import Icon from "/components/common/icon";
import clsx from "clsx";
import { setShowMobileMenu } from "/redux/action-creaters/pageState";
import { useRouter } from "next/router";
import Menu from "../menu";
import DetectedCity from "../detectedCity";
import styles from "./index.module.scss";
import Tg from "../../../common/feedBack/tg";
import Loader from "../../../common/loader";
import Max from "../../../common/feedBack/max";

export default React.memo(function Header({
  contacts,
  shops = [],
  user,
  basket,
  isScrolled,
}) {
  const dispatch = useDispatch();
  const { cityName, edostMinDays } = useSelector((state) => state.location);
  const { isShowMobileMenu } = useSelector((state) => state.pageState);
  const [searchActivate, setSearchActive] = useState(0);

  const phone = useMemo(() => {
    setTimeout(() => {
      if (typeof window === "object") {
        // eslint-disable-next-line no-unused-expressions
        window?.ct_replace_495 && window?.ct_replace_495();
        // eslint-disable-next-line no-unused-expressions
        window?.ct_replace_812 && window?.ct_replace_812();
        // eslint-disable-next-line no-unused-expressions
        window?.ct_replace_800 && window?.ct_replace_800();
      }
    }, 500);
    return contacts?.phone;
  }, [contacts]);

  const deliveryInfo = useMemo(() => {
    if (!contacts) {
      return "";
    }
    if (contacts.name === "Центральный") {
      if (edostMinDays?.days > 0) {
        return `Доставка от ${declOfNum(edostMinDays.days, ["дня", "дней", "дней"])}`;
      }
      return "";
    }
    // «0 магазинов» — не подпись: на странице ошибки список магазинов
    // не загружается, да и в норме нулевое значение показывать незачем
    if (!shops?.length) {
      return "";
    }
    return declOfNum(shops.length, ["магазин", "магазина", "магазинов"]);
  }, [contacts, shops, edostMinDays]);

  const router = useRouter();
  const isCheckoutPage = useMemo(() => {
    if (router.asPath.indexOf("/personal/cart/") > -1) {
      return true;
    }
    return false;
  }, [router]);

  const [pageScroll, setPageScroll] = useState(0);

  useEffect(() => {
    if (!isShowMobileMenu) {
      window.scrollTo(0, pageScroll);
    }
  }, [isShowMobileMenu]);

  return (
    <header>
      <DetectedCity />
      <div className={styles.HeaderWpapper}>
        <div className={styles.Header}>
          <div
            className={clsx(
              styles.Top,
              isScrolled && styles.TopScrolled,
              isShowMobileMenu && styles.TopMobiled,
            )}
          >
            <div className="container">
              <div className={styles.TopLeft}>
                <div
                  className={styles.Location}
                  data-test="headerCityButton"
                  onClick={() => dispatch(showPopup(popupTypes.locationNew))}
                >
                  {cityName && (
                    <>
                      <div
                        data-test="headerCityName"
                        className={clsx(
                          styles.City,
                          deliveryInfo && styles.CityWithDeliveryInfo,
                        )}
                      >
                        {cityName}
                        <Icon id="down" width={10} height={5} />
                      </div>
                      {deliveryInfo && <span>{deliveryInfo}</span>}
                    </>
                  )}
                  {!cityName && <Loader width={25} />}
                </div>
                <div className={styles.Socs}>
                  <Max />
                  <Tg />
                </div>
                <div className={styles.Phone}>
                  <a
                    id="phoneLink"
                    // Контактов нет (страница ошибки рендерится без серверных данных) —
                    // ссылку не рисуем вовсе: «tel:undefined» ведёт в никуда
                    href={phone ? `tel:${phone}` : undefined}
                    className={contacts?.calltouchCode}
                    onClick={() => {
                      if (
                        window.location.href.includes(
                          "vnesenie-izmeneniy-v-konstruktsiyu-ts-posle-ustanovki-farkopa_v_moskve",
                        )
                      ) {
                        if (typeof ym !== "undefined") {
                          // eslint-disable-next-line no-undef
                          ym(20518312, "reachGoal", "mskRegPhoneClick");
                        }
                      } else if (
                        window.location.href.includes(
                          "vnesenie-izmeneniy-v-konstruktsiyu-ts-posle-ustanovki-farkopa_v_sankt-peterburge",
                        )
                      ) {
                        if (typeof ym !== "undefined") {
                          // eslint-disable-next-line no-undef
                          ym(20518312, "reachGoal", "spbRegPhoneClick");
                        }
                      }
                    }}
                  >
                    {phone}
                  </a>
                  <span>Ежедневно с 09:00 до 21:00 (по Мск)</span>
                </div>
              </div>

              <Menu />
            </div>
          </div>
          <div className={styles.BodyWrapper}>
            <div
              className={clsx(
                styles.Body,
                isScrolled && styles.BodyFixed,
                isShowMobileMenu && styles.BodyMobileMenu,
              )}
            >
              <div className="container">
                <div className={clsx(styles.Icons, styles.IconsMobile)}>
                  <div
                    className={clsx(
                      styles.Menu,
                      isShowMobileMenu && styles.MenuActive,
                    )}
                    onClick={() => {
                      if (!isShowMobileMenu) {
                        setPageScroll(window.scrollY);
                        window.scrollTo(0, 0);
                      }

                      dispatch(setShowMobileMenu(!isShowMobileMenu));
                    }}
                  >
                    <div>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <Button
                    type={"none"}
                    onClick={() => {
                      setSearchActive((i) => i + 1);
                    }}
                    ariaLabel={"Открыть поиск"}
                    before={
                      <Icon
                        id="search"
                        stroke={"#9294A9"}
                        strokeWidth={2}
                        size={24}
                      />
                    }
                    customStyles={clsx(
                      styles.ButtonMobile,
                      isShowMobileMenu && styles.ButtonMobileActive,
                    )}
                  />
                </div>

                <Link href="/">
                  <a className={styles.Logo}>
                    <img src="/logo2.svg" />
                  </a>
                </Link>
                <Catalog isScrolled={isScrolled} />
                <div
                  className={clsx(
                    styles.Icons,
                    isShowMobileMenu && styles.IconsMenuActive,
                    isScrolled && styles.IconsScrolled,
                  )}
                >
                  <Search activate={searchActivate} isScrolled={isScrolled} />
                  <User user={user} />
                  {!isCheckoutPage && <Cart basket={basket} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
});
